import { Nullable } from 'legacy/lut/classes/models/utils'
import { IDescriptionQualityResult } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/descriptionQuality/models'
import { TInvestmentSourceValue } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/investmentSource/models'

import { KeyInitiativeInitTypes } from '../../../../models/keyInitiativeInitTypes'
import { EKeyInitiativeGoalMode } from '../helpers/keyInitiativeGoalMode'

export interface IKeyInitiativeForm {
  entryId?: number
  previousEntryId?: Nullable<number>
  isPracticeDevelopment: boolean
  status: string
  name: string
  keyObjective: string
  // Derived from the selected SI; not the editor's current offering context.
  programType?: string | null
  businessPriorities: string[]
  keyObjectiveTags: string[]
  period: string[]
  owner: string
  activityType: string
  hpInvestmentSum?: number
  hpInvestmentSource?: TInvestmentSourceValue
  businessUnit: string
  focusArea: string
  practiceBuilder: string
  description: string
  descriptionQuality: Nullable<IDescriptionQualityResult>
  currentProgress: string
  followUp: string
  /** Bridge participation, not the source of goalMode; Incremental selection enables this flag. */
  shouldAddToBridges: boolean
  // Editor-only selection. No Sales Target is persisted as zero Goal and Incremental values.
  goalMode?: EKeyInitiativeGoalMode
  isDataInsightRelated: boolean

  currency: string
  valueType: string
  // Serialized IKeyInitiativeOutcomeItem[] stored in the API Outcome field.
  outcome: string
  outcomeValueType: Nullable<string>
  funnelSize: Nullable<number>
  leads: Nullable<number>
  conversionRate: Nullable<number>
  attendance: Nullable<number>
  // Editor-only state; it is intentionally not mapped to the API payload.
  isEstimateSalesManuallyEdited?: boolean

  goalNdp: number
  goalNdpUsd: number
  goalNdpLocalCurrency: number
  goalNet: number
  goalNetUsd: number
  goalNetLocalCurrency: number
  goalTNet: number
  goalTNetUsd: number
  goalTNetLocalCurrency: number
  goalUTNet: number
  goalUTNetUsd: number
  goalUTNetLocalCurrency: number

  incrementalNdp: number
  incrementalNdpUsd: number
  incrementalNdpLocalCurrency: number
  incrementalNet: number
  incrementalNetUsd: number
  incrementalNetLocalCurrency: number
  incrementalTNet: number
  incrementalTNetUsd: number
  incrementalTNetLocalCurrency: number
  incrementalUTNet: number
  incrementalUTNetUsd: number
  incrementalUTNetLocalCurrency: number

  justification: string

  // autocreated key initiative
  goalDescription: Nullable<string>
  isAchieved: Nullable<boolean>
  proofOfExecution: Nullable<string>
  initType: Nullable<KeyInitiativeInitTypes>
  isNotApplicable: boolean
  isFromGlobalPartner: boolean

  isInvestmentNeeds?: boolean
}

export type TKeyInitiativeEstimateSalesTargetField = keyof Pick<
  IKeyInitiativeForm,
  | 'goalNdp'
  | 'goalNet'
  | 'goalTNet'
  | 'goalUTNet'
  | 'incrementalNdp'
  | 'incrementalNet'
  | 'incrementalTNet'
  | 'incrementalUTNet'
>

export const KEY_INITIATIVE_SALES_TARGET_FIELDS = [
  'goalNdp',
  'goalNdpUsd',
  'goalNdpLocalCurrency',
  'goalNet',
  'goalNetUsd',
  'goalNetLocalCurrency',
  'goalTNet',
  'goalTNetUsd',
  'goalTNetLocalCurrency',
  'goalUTNet',
  'goalUTNetUsd',
  'goalUTNetLocalCurrency',
  'incrementalNdp',
  'incrementalNdpUsd',
  'incrementalNdpLocalCurrency',
  'incrementalNet',
  'incrementalNetUsd',
  'incrementalNetLocalCurrency',
  'incrementalTNet',
  'incrementalTNetUsd',
  'incrementalTNetLocalCurrency',
  'incrementalUTNet',
  'incrementalUTNetUsd',
  'incrementalUTNetLocalCurrency',
] as const
